import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    entity: null,
    leaderBoard: null,
    expectedMoreData: true,
    onlyMySegmentLeaderBoard: {},
    segmentsFilters: {
        keyword: '',
        myFavorites: false,
        mineOnly: true,
        activityTypePk: [0],
        classificationPk: [1],
        surfaceTypePk: [1],
        groupPk: [],
        minGrade: '',
        maxGrade: '',
        minDistance: '',
        maxDistance: ''
    },
    filtersSectionOpenedState: {
        activeSegmentDistanceTypeFilter: false,
        activeSegmentAverageGradeFilter: false
    },
    fetchError: false
};

const receiveSegments = (state) => {
    return {
        ...state,
        isFetching: false,
        fetchError: false
    };
};

const receiveSegmentError = (state, action) => {
    return {
        ...state,
        isFetching: false,
        fetchError: true
    };
};

const receiveSegmentDetails = (state, action) => {
    return {
        ...state,
        entity: action.data,
        isFetching: false,
        fetchError: false
    };
};

const requestSegmentDetails = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const requestSegmentLeaderBoard = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveSegmentLeaderBoard = (state, action) => {
    let actionData = Object.assign({}, action.data);

    if (action.isEndlessLoading) {
        actionData.leaderboardRowDTOList =
            !!state.leaderBoard && !!state.leaderBoard.leaderboardRowDTOList
                ? state.leaderBoard.leaderboardRowDTOList.concat(action.data.leaderboardRowDTOList)
                : actionData.leaderboardRowDTOList;
    }

    return {
        ...state,
        leaderBoard: actionData,
        isFetching: false,
        expectedMoreData: !!(
            action.data &&
            action.data.leaderboardRowDTOList &&
            action.data.leaderboardRowDTOList.length &&
            actionData.leaderboardRowDTOList.length > 8
        )
    };
};

const requestOnlyMySegmentLeaderBoard = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveOnlyMySegmentLeaderBoard = (state, action) => {
    return {
        ...state,
        onlyMySegmentLeaderBoard: {
            ...state.onlyMySegmentLeaderBoard,
            [action.data.uuid]: action.data
        },
        isFetching: false
    };
};

const requestOnlyMySegmentLeaderBoardFail = (state, action) => {
    return {
        ...state,
        onlyMySegmentLeaderBoard: action.data,
        isFetching: false
    };
};

const setOpenedFilter = (state, action) => {
    return {
        ...state,
        filtersSectionOpenedState: {
            ...state.filtersSectionOpenedState,
            [action.data]: !state.filtersSectionOpenedState[action.data]
        }
    };
};

const resetOpenedFilter = (state) => {
    return {
        ...state,
        filtersSectionOpenedState: {
            filtersSectionOpenedState: INITIAL_STATE.filtersSectionOpenedState
        }
    };
};

const setSegmentsFilters = (state, data) => {
    let setFilter = data.filterValue;

    if (typeof state.segmentsFilters[data.filterName] === 'object') {
        if (data.onlyOneValueSelected) {
            setFilter = [];
        } else {
            setFilter = state.segmentsFilters[data.filterName];
        }

        let valueIndexInArray = setFilter.indexOf(data.filterValue);
        if (valueIndexInArray !== -1) {
            setFilter.splice(valueIndexInArray, 1);
        } else {
            setFilter.push(data.filterValue);
        }
    }

    return {
        ...state,
        segmentsFilters: {
            ...state.segmentsFilters,
            [data.filterName]: setFilter
        }
    };
};

const resetSegmentInfo = (state) => {
    let onlyMeLeaderboard = state.onlyMySegmentLeaderBoard;
    return {
        ...INITIAL_STATE,
        onlyMySegmentLeaderBoard: onlyMeLeaderboard,
        segmentsFilters: state.segmentsFilters
    };
};

const addRemoveFromFavoritesInSegmentDetails = (state, action) => {
    if (state.entity) {
        return {
            ...state,
            entity: {
                ...state.entity,
                favorite: action.favorite
            }
        };
    } else {
        return {
            ...state
        };
    }
};

const handlers = {
    [types.REQUEST_SEGMENT_DETAILS]: requestSegmentDetails,
    [types.RESET_SEGMENT_INFO]: resetSegmentInfo,
    [types.RECEIVE_SEGMENT_DETAILS]: receiveSegmentDetails,
    [types.REQUEST_SEGMENT_LEADERBOARD]: requestSegmentLeaderBoard,
    [types.RECEIVE_SEGMENT_LEADERBOARD]: receiveSegmentLeaderBoard,
    [types.REQUEST_SEGMENT_LEADERBOARD_ONLY_ME]: requestOnlyMySegmentLeaderBoard,
    [types.RECEIVE_SEGMENT_LEADERBOARD_ONLY_ME]: receiveOnlyMySegmentLeaderBoard,
    [types.REQUEST_SEGMENT_LEADERBOARD_ONLY_ME_FAIL]: requestOnlyMySegmentLeaderBoardFail,
    [types.TOGGLE_FAVORITE_SEGMENT_IN_SEGMENT_DETAILS]: addRemoveFromFavoritesInSegmentDetails,
    [types.SET_OPENED_FILTER]: setOpenedFilter,
    [types.RESET_OPENED_FILTER]: resetOpenedFilter,
    [types.SET_SEGMENTS_FILTERS]: setSegmentsFilters,
    [types.RECEIVE_SEGMENTS]: receiveSegments,
    [types.RECEIVE_SEGMENTS_ERROR]: receiveSegmentError
};

export const getSegmentDetails = (state) => state.segment.entity;
export const getSegmentsFilters = (state) => state.segment.segmentsFilters;
export const getOpenedFilter = (state) => state.segment.filtersSectionOpenedState;
export const getSegmentLeaderBoard = (state) => state.segment;
export const getOnlyMySegmentLeaderBoard = (state, uuid) => state.segment.onlyMySegmentLeaderBoard[uuid] || {};
export const isSegmentDetailsError = (state) => state.segment.fetchError;

export default function segment(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
